(ns ui.data.app-core.sub
  (:require
   [re-frame.core :as rf]
   [frontend.state.current-session :as session]))

(rf/reg-sub
 ::tenant
 (fn [_ _]
   @session/tenant))

(rf/reg-sub
 ::account
 (fn [_ _]
   @session/account))

(rf/reg-sub
 ::role
 (fn [_ _]
   @session/role))

(rf/reg-sub
 ::tenant-modules
 (fn [_ _]
   @session/tenant-modules))

(rf/reg-sub
 ::account-preferences
 (fn [_ _]
   @session/account-preferences))

(rf/reg-sub
 ::tenant-preferences
 (fn [_ _]
   @session/tenant-preferences))

(rf/reg-sub
 ::is-admin?
 (fn [_ _]
   (session/is-admin?)))

(rf/reg-sub
 ::is-read-only-user?
 (fn [_ _]
   (session/is-read-only-user?)))

(rf/reg-sub
 ::new-company-viewer-preview-2024?
 (fn [_ _]
   (session/new-company-viewer-preview-2024?)))

(rf/reg-sub
 ::current-module
 (fn [_ _]
   (session/current-module)))
